import { Base } from "../../framework/base";
import { IInstantMessageChannelItem, InstantMessageChannelItem } from "./instantMessageChannelItem";

export interface IInstantMessageChannelItems {
    channels: IInstantMessageChannelItem[];
}

export class InstantMessageChannelItems implements IInstantMessageChannelItems {
    channels: InstantMessageChannelItem[];

    constructor();
    constructor(obj: IInstantMessageChannelItems);
    constructor(obj?: any) {
        this.channels = Base.getTypedArray<InstantMessageChannelItem>(obj ? obj.channels : null, InstantMessageChannelItem);
    }
}